<template>
  <p>
    The VIZBI 2011 posters are available at
    <a href="http://vizbi.org/Posters/2011/">vizbi.org/Posters/2011</a>.
  </p>
</template>
